import type { BillingPlatformFeeCoupon, BillingPlatformFeePlan } from "./types/Billing";
import { hFetch } from "./hFetch";

export type ListResponse<T> = {
  records: T[];
  status: 'success' | 'error';
  message?: string;
};

export type DetailResponse<T> = {
  record: T;
  status: 'success' | 'error';
  message?: string;
};

export const listPlatformFeePlans = async () => {
  return await hFetch<ListResponse<BillingPlatformFeePlan>>({ url: '/api/billing/platform_fee_plans' });
};

export const listPlatformFeeCoupons = async () => {
  return await hFetch<ListResponse<BillingPlatformFeeCoupon>>({ url: '/api/billing/platform_fee_coupons' });
};

export const getPlatformFeePlan = async (id: string) => {
  return await hFetch<DetailResponse<BillingPlatformFeePlan>>({ url: `/api/billing/platform_fee_plans/${id}` });
};

export const getPlatformFeeCoupon = async (id: string) => {
  return await hFetch<DetailResponse<BillingPlatformFeeCoupon>>({ url: `/api/billing/platform_fee_coupons/${id}` });
};
